import { render, staticRenderFns } from "./AIEvaluationReviewWorkspace_v2.vue?vue&type=template&id=7a8667cd&scoped=true&"
import script from "./AIEvaluationReviewWorkspace_v2.vue?vue&type=script&lang=js&"
export * from "./AIEvaluationReviewWorkspace_v2.vue?vue&type=script&lang=js&"
import style0 from "./AIEvaluationReviewWorkspace_v2.vue?vue&type=style&index=0&id=7a8667cd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8667cd",
  null
  
)

export default component.exports